module.exports = __webpack_public_path__ + "static/media/about.faadc415.jpg";